export default __webpack_public_path__ + "static/OgImage-84a149e45403ba66a48fe42bd541d963.png";